// extracted by mini-css-extract-plugin
module.exports = {"action":"AllowancesTable__action--1-yuO"};